import React, { useState } from 'react';
import { SpacingSizes } from '../Stack/Stack';
import { SortableList } from './SortableList';

const options = ['xs', 'sm', 'default', 'lg', 'xl'];

export function SortableListExample(): JSX.Element {
  const [size, setSize] = useState<SpacingSizes>('default');

  return (
    <>
      <select onChange={(e) => setSize(e.target.value as SpacingSizes)} value={size}>
        {options.map((item) => {
          return (
            <option key={item} value={item}>
              {item}
            </option>
          );
        })}
      </select>
      <SortableList
        size={size}
        items={[
          {
            band: 'The Beatles',
            members: '4',
            year: '1960',
            country: 'United Kingdom',
          },
          {
            band: 'The Rolling Stones',
            members: '4',
            year: '1962',
            country: 'United Kingdom',
          },
          {
            band: 'Nirvana',
            members: '3',
            year: '1987',
            country: 'United States',
          },
        ]}
        columns={[
          { width: 150, label: 'Band', sortable: false, dataKey: 'band' },
          {
            width: 120,
            label: 'Number of members',
            sortable: true,
            dataKey: 'members',
            sortRenderer: (row) => row.year,
          },
          {
            width: 150,
            label: 'Country of origin',
            sortable: false,
            dataKey: 'country',
          },
        ]}
      />
    </>
  );
}
